import * as state from './state'
import { resetContentState } from './methods/reset-content-state'
import { saveContent } from './methods/save-content'
import { publishContent } from './methods/publish-content'

/**
 * Composable for managing content operations
 * @returns {Object} Content management state and methods
 */
export function useContentManagement() {
  return {
    // State
    contentId: state.contentId,
    isSaving: state.isSaving,
    isPublishing: state.isPublishing,
    isSaved: state.isSaved,
    isPublished: state.isPublished,
    contentAnalytics: state.contentAnalytics,
    
    // Methods
    resetContentState,
    saveContent,
    publishContent,
  }
}
